export default "__VITE_ASSET__l$IrMX9I__"